import api from "./base-api"

const mcSyncConflictsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getSyncConflictsMC: build.query({
            query: ({ stateId, vendorId, page = 0, limit = 25 }) => {
                const p = new URLSearchParams({ page, limit })
                if (stateId && stateId.trim()) p.set("stateId", stateId.trim())
                if (vendorId && vendorId.trim()) p.set("vendorId", vendorId.trim())
                return `v3/mc/sync-conflicts?${p.toString()}`
            },
            providesTags: ["SyncConflictsMC"]
        }),
        getSyncConflictMC: build.query({
            query: (id) => `v3/mc/sync-conflicts/${id}`,
            providesTags: (_r, _e, id) => [{ type: "SyncConflictsMC", id }]
        })
    }),
    overrideExisting: false
})

export const {
    useGetSyncConflictsMCQuery,
    useGetSyncConflictMCQuery
} = mcSyncConflictsApi
